import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';
import { SET_CURRENT_CITY, TSetCurrentCity } from '@r1-frontend/entities/stores/city/reducer';

export const setCurrentCity = (currentCity: ICurrentCity): TSetCurrentCity => ({
    type: SET_CURRENT_CITY,
    payload: {
        currentCity,
    },
});
